import { render } from "./PageDelete.vue?vue&type=template&id=fa611ae6"
import script from "./PageDelete.vue?vue&type=script&lang=js"
export * from "./PageDelete.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.18.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__